import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";

import {USER_LOCALSTORAGE_KEY} from "shared/const/localstorage";
import {createRequestParams} from "common/hook/create-request-params/createRequestParams";
import {StatisticsResponse} from "features/model/types/hr/getStatistics";
import {
    setStatisticsData,
    setStatisticsFilters,
} from "features/model/slice/hr/statistics/statisticsSlice";
import {RootState} from "app/store";


interface GetStatisticsParams {
    from?: string;
    to?: string;
    page?: number;
    group_id?:number | null | undefined;
}


export const getStatistics = createAsyncThunk(
    "hr/getStatistics",
    async ({  from, to, page,group_id }: GetStatisticsParams, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error("No token found in localStorage.");
            }
            const { token } = JSON.parse(authToken);

            const state = thunkAPI.getState() as RootState;
            const filters = state.statistics.filters;
            const resolvedFrom = from !== undefined ? from : filters.from;
            const resolvedTo = to !== undefined ? to : filters.to;
            const resolvedGroupId = group_id !== undefined ? group_id : filters.group_id;
            const resolvedPage = page !== undefined ? page : 0;

            thunkAPI.dispatch(setStatisticsFilters({
                from: resolvedFrom || '',
                to: resolvedTo || '',
                group_id: resolvedGroupId ?? null,
            }));

            const params = createRequestParams(resolvedFrom, resolvedTo, resolvedPage, resolvedGroupId);

            const response = await axios.get<StatisticsResponse>(
                `/api/statistics`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    params,
                }
            );

            if (response.data && response.data.success) {
                thunkAPI.dispatch(setStatisticsData(response.data.data));
            }

            return response.data;
        } catch (e) {
            return thunkAPI.rejectWithValue("error");
        }
    }
);
